// Content of the free "100 refranes y dichos populares en España" lead magnet.
// The PDF itself lives in the backend (gated download), never as a public URL.
export const REFRANES_GUIA = {
  slug: 'refranes-dichos-populares-espanoles',
  title: '100 refranes y dichos populares en España',
  level: 'B1-C1',
  category: 'vocabulary',
  format: 'PDF · 24 páginas',
  description:
    'Aprende 100 refranes, dichos y expresiones populares que se usan realmente en España, con significado, ejemplos y equivalencias en inglés y alemán. El PDF también contiene una actividad final para practicar lo aprendido.',
  seoTitle: '100 refranes y dichos populares en España | PDF gratis',
  seoDescription:
    'Descarga gratis una guía con 100 refranes y dichos populares en España, con significado, ejemplos y equivalencias en inglés y alemán. Nivel B1–C1.',
  cover: '/recursos/refranes-portada.jpg',
};

export const REFRANES_EJEMPLOS = [
  {
    refran: 'Más vale tarde que nunca',
    significado: 'Es preferible hacer algo con retraso que no hacerlo en absoluto.',
    ejemplo: 'Empecé a estudiar español a los cincuenta. Más vale tarde que nunca.',
    en: 'Better late than never.',
    de: 'Besser spät als nie.',
  },
  {
    refran: 'A quien madruga, Dios le ayuda',
    significado: 'La iniciativa y el esfuerzo temprano suelen traer ventajas.',
    ejemplo: 'Conseguimos las mejores entradas porque fuimos temprano: a quien madruga, Dios le ayuda.',
    en: 'The early bird catches the worm.',
    de: 'Morgenstund hat Gold im Mund.',
  },
  {
    refran: 'No dejes para mañana lo que puedas hacer hoy',
    significado: 'Conviene evitar la procrastinación y resolver las tareas a tiempo.',
    ejemplo: 'Envía hoy la solicitud; no dejes para mañana lo que puedas hacer hoy.',
    en: 'Never put off until tomorrow what you can do today.',
    de: 'Was du heute kannst besorgen, das verschiebe nicht auf morgen.',
  },
  {
    refran: 'Estar en las nubes',
    significado: 'Estar distraído o pensando en otra cosa.',
    ejemplo: 'Te he preguntado dos veces y no respondes; estás en las nubes.',
    en: "To have one's head in the clouds.",
    de: 'Mit dem Kopf in den Wolken sein.',
  },
  {
    refran: 'Meter la pata',
    significado: 'Cometer un error, especialmente al decir o hacer algo inoportuno.',
    ejemplo: 'Le pregunté por su novio sin saber que habían roto. Metí la pata.',
    en: "To put one's foot in it.",
    de: 'Ins Fettnäpfchen treten.',
  },
  {
    refran: 'Ser pan comido',
    significado: 'Resultar muy fácil de hacer o resolver.',
    ejemplo: 'Después de practicar, el examen fue pan comido.',
    en: 'To be a piece of cake.',
    de: 'Ein Kinderspiel sein.',
  },
];
